import { createAction } from 'redux-actions';

export const SELECT_STUDENT = 'SELECT_STUDENT';

const selectStudent = createAction(SELECT_STUDENT);

export default {
    selectStudent
};



// WEBPACK FOOTER //
// ./containers/class-details/selected-student-actions.js